import PropTypes from 'prop-types';
import { useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
// hooks
import useAuth from '../hooks/useAuth';
// pages
import Login from '../pages/admin/auth/AdminLogin';
// components
import LoadingScreen from '../components/LoadingScreen';
// utils
import { saveReturnTo } from '../utils/returnTo';

// ----------------------------------------------------------------------

AdminAuthGuard.propTypes = {
  children: PropTypes.node,
};

export default function AdminAuthGuard({ children }) {
  const { isAuthenticated, isInitialized } = useAuth();

  const { pathname, search } = useLocation();

  const [requestedLocation, setRequestedLocation] = useState(null);

  if (!isInitialized) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated) {
    if (pathname !== requestedLocation) {
      setRequestedLocation(pathname);
      // Login goes through /auth/crossing and unmounts this guard, so the
      // state above is lost. Crossing reads this back instead.
      saveReturnTo(`${pathname}${search}`);
    }
    return <Login />;
  }

  if (requestedLocation && pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  return <>{children}</>;
}
